import React from "react";
import {CButton} from "@coreui/react";
import { useNavigate } from "react-router-dom";

const Error401 = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/login");
  };

  return (
    <div style={{ textAlign: "center" }}>
      <img loading="lazy"
        src="/custom_icon/error404.png"
        alt="404 Error"
        style={{
          maxWidth: "100%",
          height: "auto",
          marginBottom: "20px",
          marginTop: "80px",
        }}
      />
      <h1 style={{ fontSize: "48px", marginBottom: "10px" }}>401 Unauthorised</h1>
      <p style={{ fontSize: "24px", marginBottom: "20px" }}>
        Sorry, you are not authorized to access this page.
      </p>
      <CButton  style={{ fontSize: "18px" }} onClick={handleClick}>
        Back Home
      </CButton>
    </div>
  );
};

export default Error401;
